import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

const FunnyErrorPage = ({ errorCode = 404, errorMessage = "Page Not Found" }) => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center" style={{
      background: "linear-gradient(to right, #6a11cb 0%, #2575fc 100%)",
      color: "#fff",
      padding: "2rem"
    }}>
      <div style={{ fontSize: "8rem", marginBottom: "1rem", animation: "bounce 2s infinite" }}>
        😵
      </div>
      <h1 className="display-1 fw-bold">Error {errorCode}</h1>
      <p className="lead mb-3">{errorMessage || "Oops! Something went wrong."}</p>
      <p className="mb-4">
        You’ve entered the Bermuda Triangle of our app. Nothing makes sense here… try finding your way back!
      </p>
      <a href="/" className="mt-4 btn btn-light btn-lg fw-semibold shadow">
        🏠 Take Me Home
      </a>

      {/* Bounce Animation */}
      <style>{`
        body{
          direction:ltr;
        }
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
      `}</style>
    </div>
  );
};

export default FunnyErrorPage;
